// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3esuw","title":"ClientCherryInfo_title__228cB","itemText":"ClientCherryInfo_itemText__3MDf1"};